import { User } from 'src/app/models/user.model';
import { Permission } from 'src/app/shared/constants/permissions';
import { environment } from 'src/environments/environment';

const isLocalOrDevEnvironment = (): boolean =>
  environment.dev || environment.siteUrl?.includes('localhost');

export const canUseSampleData = (user: User | null | undefined): boolean =>
  isLocalOrDevEnvironment() ||
  !!user?.Account?.Is_Demo_Account__c ||
  (user?.Permissions ?? []).includes(Permission.NITEL_INTERNAL);
